import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const OtherPositionInputLabel = styled(typography.P2RegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const OtherPositionInputField = styled.input`
  width: 100%;
  height: 40px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey006};
    outline: none;
  }
`;

export const FormValidationError = styled(typography.P2RegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redDark};
`;
